import React, { useEffect, useState } from 'react';
import type { FieldSelectorProps } from 'react-querybuilder';

import { formatOptions } from '../helper';

import VirtualizeAutocomplete from '../../VirtualizeAutocomplete/VirtualizedAutocomplete';

const CustomFieldSelector: React.FC<FieldSelectorProps> = ({
  value,
  options,
  disabled,
  handleOnChange,
}) => {
  const [valueSelected, setValueSelected] = useState<any>();

  useEffect(() => {
    const formattedOptions = formatOptions(options);
    const foundValue = formattedOptions.find((el) => el.name === value);
    setValueSelected(foundValue);
  }, [value, options]);

  return (
    <div className="custom-field-selector-container">
      <VirtualizeAutocomplete
        groupedOptions={options ? formatOptions(options) : []}
        handleChange={(event: any, value: any) =>
          handleOnChange(value ? value.name : '')
        }
        value={valueSelected}
        label="Field"
        disabled={disabled}
      />
    </div>
  );
};

export default CustomFieldSelector;
